"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVipInfo = getVipInfo;
exports.sendEmailCode = sendEmailCode;
exports.verifyMail = verifyMail;

var _request = _interopRequireDefault(require("@/utils/request"));

// 获取vip信息
function getVipInfo() {
  return (0, _request.default)({
    url: '/performance/user/vipInfo',
    method: 'get'
  });
} // 发送邮箱验证码


function sendEmailCode(data) {
  return (0, _request.default)({
    url: '/user/sendMailCode',
    method: 'post',
    data: data
  });
}

function verifyMail(data) {
  return (0, _request.default)({
    url: '/user/verifyMail',
    method: 'post',
    data: data
  });
}